<template>
  <div class="modal-overlay">
    <div class="modal" ref="modalRef" tabindex="-1">

      <!-- HEADER -->
      <div class="header-bar">
        <div class="nav-arrows">
          <button @click="goBack">‹</button>
          <button @click="goForward">›</button>
        </div>

        <div class="breadcrumb">
          <img :src="folderIcon" class="crumb-icon" />
          <span>/</span>
          <span>{{ currentPath }}</span>
        </div>
      </div>

      <!-- TABS -->
      <div class="tabs">
        <button
          :class="{ active: driverKind === 'P' }"
          @click="changeDriver('P')"
        >
          User's Drive
        </button>

        <button
          :class="{ active: driverKind === 'D' }"
          @click="changeDriver('D')"
        >
          Public Drive
        </button>
      </div>

      <!-- GRID -->
      <div class="file-grid">
<div
  v-for="item in items"
  :key="item.FILE_KEY"
  class="file-card"
  :class="{ selected: selectedKey === item.FILE_KEY }"
  tabindex="0"
  :aria-label="`Select ${item.FILE_TYPE === 'FOLDER' ? 'folder' : 'file'} named ${item.FILE_NAME}`"
  @click="selectItem(item)"
  @dblclick="openFolder(item)"
  @keyup.enter.prevent="item.FILE_TYPE === 'FOLDER' ? openFolder(item) : selectItem(item)"
>


          <!-- FOLDER -->
          <div v-if="item.FILE_TYPE === 'FOLDER'" class="folder-icon">
            <img :src="folderIcon" class="file-icon" />
          </div>

          <!-- FILE -->
          <div v-else class="icon-wrapper">
            <img :src="fileIcon" class="file-icon" />
          </div>

          <div class="name">{{ item.FILE_NAME }}</div>

          <div v-if="item.FILE_TYPE === 'FOLDER'" class="count">
            {{ item.FILE_COUNT }} items
          </div>
        </div>
      </div>

      <!-- PAGINATION -->
      <div class="pagination" v-if="totalPages > 1">
        <button @click="goFirst">«</button>
        <button @click="goPrev">‹</button>

        <button
          v-for="page in totalPages"
          :key="page"
          :class="{ active: page === currentPage }"
          @click="goPage(page)"
        >
          {{ page }}
        </button>

        <button @click="goNext">›</button>
        <button @click="goLast">»</button>
      </div>

      <!-- ACTIONS -->
      <div class="modal-actions">
        <button class="cancel-btn" @click="$emit('close')">
          Cancel
        </button>

<button
  class="import-btn"
  :disabled="!selectedKey || !isFileSelected"

  @click="goToCanvas"
>
  Import
</button>

      </div>

    </div>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService"
import folderIcon from "@/assets/img/folder.svg"
import fileIcon from "@/assets/img/file.svg"

export default {
  name: "DotCloud",

  data() {
    return {
      items: [],
      currentPage: 1,
      pageSize: 9,
      totalCount: 0,
      currentParent: "ROOT",
      driverKind: "P",
      pathStack: [{ FILE_KEY: "ROOT", FILE_NAME: "Untitle" }],
      historyStack: [],
      selectedKey: null,
      folderIcon,
      fileIcon
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize)
    },
currentPath() {
  return this.pathStack
    .map(p => p.FILE_NAME)
    .join(" / ")
},
isFileSelected() {
    const item = this.items.find(i => i.FILE_KEY === this.selectedKey)
    return item && item.FILE_TYPE === "FILE"
  }

  },

  mounted() {
    this.fetchDrive();
    this.$nextTick(() => {
      this.$refs.modalRef?.focus();
    });
    document.addEventListener("focusin", this.keepFocusInModal, true);
    document.addEventListener("keydown", this.trapFocusKeys);
  },

  beforeUnmount() {
    document.removeEventListener('focusin', this.keepFocusInModal, true);
    document.removeEventListener('keydown', this.trapFocusKeys);
  },

  methods: {
    async fetchDrive() {
      const userNo = localStorage.getItem("USER_NO")

      const res = await ApiService.getDriveList(
        this.currentPage,
        this.currentParent,
        this.driverKind,
        userNo
      )

      this.items = res?.items || []
      this.totalCount = Number(res?.totalCount || 0)
    },

keepFocusInModal(event) {
  if (!this.$refs.modalRef) return;
  if (!this.$refs.modalRef.contains(event.target) && event.target !== this.$refs.modalRef) {
    event.stopPropagation();
    this.$refs.modalRef.focus();
  }
},

trapFocusKeys(event) {
  if (event.key !== 'Tab') return;
  if (!this.$refs.modalRef) return;

  const focusable = Array.from(this.$refs.modalRef.querySelectorAll(
    'a[href], input:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
  ));
  if (focusable.length === 0) return;

  const firstEl = focusable[0];
  const lastEl = focusable[focusable.length - 1];

  if (document.activeElement === this.$refs.modalRef) {
    event.preventDefault();
    if (event.shiftKey) lastEl.focus();
    else firstEl.focus();
    return;
  }

  if (event.shiftKey && document.activeElement === firstEl) {
    event.preventDefault();
    lastEl.focus();
  } else if (!event.shiftKey && document.activeElement === lastEl) {
    event.preventDefault();
    firstEl.focus();
  }
},


selectItem(item) {
  if (item.FILE_TYPE !== "FILE") {
    this.selectedKey = null
    return
  }

  this.selectedKey = item.FILE_KEY
},


openFolder(item) {
  if (item.FILE_TYPE === "FOLDER") {
    this.currentParent = item.FILE_KEY
    this.currentPage = 1

    this.pathStack.push({
      FILE_KEY: item.FILE_KEY,
      FILE_NAME: item.FILE_NAME
    })

    this.selectedKey = null   // 🔥 선택 초기화
    this.fetchDrive()
  }
},



    changeDriver(kind) {
      this.driverKind = kind
      this.currentPage = 1
      this.fetchDrive()
    },

    goPage(page) {
      this.currentPage = page
      this.fetchDrive()
    },

    goFirst() {
      this.currentPage = 1
      this.fetchDrive()
    },

    goLast() {
      this.currentPage = this.totalPages
      this.fetchDrive()
    },

    goPrev() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchDrive()
      }
    },

    goNext() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.fetchDrive()
      }
    },
goBack() {
  if (this.pathStack.length > 1) {
    const last = this.pathStack.pop()
    this.historyStack.push(last)   // 🔥 앞으로 갈 수 있게 저장

    const prev = this.pathStack[this.pathStack.length - 1]

    this.currentParent = prev.FILE_KEY || "ROOT"
    this.fetchDrive()
  }
}

,

   goForward() {
  if (this.historyStack.length > 0) {
    const next = this.historyStack.pop()
    this.pathStack.push(next)

    this.currentParent = next.FILE_KEY
    this.fetchDrive()
  }
},
goToCanvas() {
  if (!this.selectedKey) return

  // 현재 경로 문자열 생성
  const fullPath = this.pathStack
    .map(p => p.FILE_NAME)
    .join("/")

  this.$router.push({
    name: "dotCanvas",
    query: {
      fileKey: this.selectedKey,
      path: fullPath
    }
  })
}


  }
}
</script>

<style scoped>

/* OVERLAY */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* MODAL */
.modal {
  width: 760px;
  height: 640px;
  background: #F7F7F7;
  border-radius: 36px;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 30px 80px rgba(0,0,0,0.18);
}

/* HEADER */
.header-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  padding: 14px 20px;
  border-radius: 40px;
  margin-bottom: 24px;
}

.nav-arrows {
  display: flex;
  gap: 8px;
}

.nav-arrows button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #dcdcdc;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
}

.crumb-icon {
  width: 18px;
}

/* TABS */
.tabs {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
  font-weight: 1000;
}

.tabs button {
  height: 44px;
  padding: 0 30px;
  border-radius: 30px;
  border: none;
  background: #e4e4e4;
  font-weight: 700;
}

.tabs button.active {
  background: #f24c0a;
  color: white;
}

/* GRID */
.file-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;

  overflow-y: auto;     /* 🔥 여기 변경 */
  overflow-x: hidden;
  padding-right: 6px;   /* 스크롤 공간 확보 */
}



.file-card {
  height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  transition: 0.2s;
}

.file-card.selected {
                /* 🔥 하얀 선택창 */
  border: 2px solid #ff5a00;         /* 🔥 주황 테두리 */
}




.folder-icon {
  width: 120px;          /* 🔥 기존보다 크게 */
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.folder-icon img {
  width: 70px;           /* 🔥 아이콘 크기 증가 */
}


.icon-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.file-icon {
  width: 48px;
}

.name {
  font-weight: 700;
  font-size: 14px;
}

.count {
  font-size: 12px;
  color: #777;
}

/* PAGINATION */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border-radius: 14px;
  padding: 6px 10px;
  margin-top: 16px;
}

.pagination button {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 6px;
}

.pagination button.active {
  background: black;
  color: white;
  outline: 2px solid #1f5cff;
}

/* ACTIONS */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 20px;
}

.cancel-btn {
  background: #bfbfbf;
  color: white;
  padding: 12px 32px;
  border-radius: 26px;
  border: none;
  font-weight: 700;
}

.import-btn {
  background: #f24c0a;
  color: white;
  padding: 12px 32px;
  border-radius: 26px;
  border: none;
  font-weight: 700;
}

.import-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}


</style>
